
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CourseDetailError = () => (
  <div className="container-custom py-16 text-center">
    <div className="bg-red-50 text-red-600 p-8 rounded-lg inline-block">
      Kursuse andmeid ei leitud või ilmnes viga.
    </div>
    <Button className="mt-8" asChild>
      <Link to="/courses">Tagasi kursuste juurde</Link>
    </Button>
  </div>
);

export default CourseDetailError;
